module.exports = __webpack_public_path__ + "img/tips-covered.438c184b.svg";